// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__dG8cc","label":"style_label__SCSMs","actions":"style_actions__12r5a","actions_btn":"style_actions_btn__IJ8gF"};